export function sellerAdvisoryVacantLandDC924() {
return [   //2024 Release 2025-06-02 15:46:50
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 58.673,
 left: 53,
 width: 180,
 height: 27,
 }, 
{
   page: 0,
   name: "undefined", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 235.68,
   width: 254.04,
   height: 10.20
}
,
{
   page: 0,
   name: "without right of transfer All rights reserved", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 117.84,
   width: 210.72,
   height: 10.20
}
,
{
   page: 0,
   name: "Text4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 141.528,
   left: 178.692,
   width: 352.255,
   height: 13.491
}
,
{
   page: 0,
   name: "Text5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 169.019,
   left: 178.692,
   width: 352.255,
   height: 13.491
}
,
{
   page: 0,
   name: "Text6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 194.546,
   left: 178.692,
   width: 352.255,
   height: 13.491
}
,
{
   page: 0,
   name: "Text7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 222.692,
   left: 178.692,
   width: 352.255,
   height: 13.491
}
,
{
   page: 1,
   name: "undefined_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 235.68,
   width: 254.04,
   height: 10.20
}
,
{
   page: 1,
   name: "without right of transfer All rights reserved_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 117.84,
   width: 210.72,
   height: 10.20
}
,
{
   page: 2,
   name: "undefined_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 235.68,
   width: 254.04,
   height: 10.20
}
,
{
   page: 2,
   name: "without right of transfer All rights reserved_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 117.84,
   width: 210.72,
   height: 10.20
}
,
{
   page: 3,
   name: "Amendment to Seller Listing Contract This Seller Advisory amends the Exclusive RighttoSell", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.52,
   left: 235.68,
   width: 254.04,
   height: 11.40
}
,
{
   page: 3,
   name: "signature Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 252.338,
   left: 72.0,
   width: 150.654,
   height: 15.982
}
,
{
   page: 3,
   name: "date sign", 
   fontSize: 9,
   type: "date",
   top: 252.338,
   left: 233.345,
   width: 51.175,
   height: 15.982
}
,
{
   page: 3,
   name: "without right of transfer All rights reserved_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 744.36,
   left: 117.84,
   width: 210.72,
   height: 10.20
}
] }
